import { NativeSelect } from '@chakra-ui/react'
import { useQuery } from '@tanstack/react-query'
import { k8sApi } from '~/lib/api'

interface NamespaceSelectorProps {
  value: string
  onChange: (namespace: string) => void
}

export function NamespaceSelector({ value, onChange }: NamespaceSelectorProps) {
  // Fetch namespaces
  const { data: namespacesData } = useQuery({
    queryKey: ['namespaces'],
    queryFn: () => k8sApi.namespaces(),
    retry: false,
  })

  const namespaces = namespacesData?.namespaces || []

  return (
    <NativeSelect.Root size="sm" w="200px">
      <NativeSelect.Field
        aria-label="Filter by namespace"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">All namespaces</option>
        {namespaces.map((ns) => (
          <option key={ns} value={ns}>
            {ns}
          </option>
        ))}
      </NativeSelect.Field>
    </NativeSelect.Root>
  )
}
